@if (isEditing) {
  <app-project-form (formSubmitted)="onProjectFormSubmitted($event)" [formData]="project"></app-project-form>
} @else {
  <div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12" *ngIf="projectExists;else notLoaded">
    <div class="custom-card-large">
      <div class="card-body d-flex row justify-content-center text-center">
        <div>
          <div class="d-flex justify-content-end">
            <button *ngIf="!project?.isDeleted && !isDeleting"
                    class="btn btn-primary delete-btn"
                    (click)="deleteProject()"
                    style="padding-bottom: 3px;">
              <span class="material-symbols-outlined">
                delete
              </span>
            </button>
            <button *ngIf="project?.isDeleted && (teacherRole === 'admin')"
                    class="btn btn-primary delete-btn"
                    (click)="undeleteProject()">
              Undelete
            </button>

          </div>
        </div>
        <div *ngIf="projectExists; else projectDoesntExist">

          <div *ngIf="project;else noProject">
            <div class="d-flex flex-column flex-md-row align-items-center justify-content-end w-100">
              <h3 class="custom-card-title custom-title my-2 mb-5">
                {{ project && project.title }}
              </h3>

              @if (userService.getUID() == project.owner) {
                <div class="d-flex align-items-center">
                  <!-- <label for="visibility" class="me-2">Visibility:</label>
                   <select (change)="onVisibilityChange($event)" name="visibility" id="visibility" class="form-select">
                     <option *ngFor="let visibility of visibilityStates" [value]="visibility" [selected]="project && visibility == project.visibility">
                       {{ visibility }}
                     </option>
                   </select>-->
                </div>
              } @else {
                <div style="visibility: hidden; width: 1px;" class="mb-3">&nbsp;</div>
              }

            </div>


            <h4>
                            <span class="material-symbols-outlined custom-card-title"
                                  style="font-size: 28px; margin-bottom: 2px; vertical-align: middle;">
                                location_on
                            </span>
              {{ project.school === 'other' && project.customSchool || project.school }}
            </h4>


            <!-- <h5>{{ project.teachingLevel | titlecase}} School</h5> -->
            @if (project.startDate && project.endDate) {
              <h5>{{ formatDate(project.startDate) + " - " + formatDate(project.endDate) }}</h5>
            }

            @if (isAdmin) {
              <div class="project-meta mt-3 mb-3 p-3 rounded-3 bg-light text-start">
                <p><strong>Project Owner:</strong></p>
                <p><strong>Created:</strong> {{ formatIsoString(project.dateSubmitted) }}</p>
                <p><strong>Last Updated:</strong> {{ formatIsoString(project.dateEdited) }}</p>
                <p><strong>Last Updated By:</strong></p>

                <!-- Show duplication info if this is a duplicate -->
                @if (project.isDuplicate && project.duplicatedFrom) {
                  <p class="mt-2">
                    <strong>Duplicated from:</strong> {{ project.duplicatedFrom.projectTitle }}
                    <br><br>

                    <strong>Duplicated on:</strong> {{ formatIsoString(project.duplicatedFrom.duplicatedOn) }}
                  </p>
                }
              </div>
            }

            <p>{{ project.projectDesc }}</p>
            <br>


            <div *ngIf="project.selectedCourses.length > 0">
              <h4 class="custom-card-title mt-4 mb-3">Courses</h4>
              <ng-container *ngFor="let course of project.selectedCourses">
                <div class="rounded-5 px-3 py-2 m-1"
                     style="background-color: #4169E1; color: white; display: inline-block; font-weight: 600;">
                  {{ course }}
                </div>
              </ng-container>
            </div>

            <div *ngIf="cards.length > 0">
              <br><br>
              <h4 class="custom-card-title mt-4 mb-4">Features</h4>
              <div class="row g-4 d-flex flex-wrap">
                <ng-container *ngFor="let card of cards">
                  <div *ngIf="card.condition" class="col-lg-4 col-md-6 col-sm-12 d-flex">
                    <div class="w-100">
                      <app-feature-card [header]="card.header" [symbol]="card.symbol"
                                        [description]="card.description">
                      </app-feature-card>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>


            <div *ngIf="project.images">
              <h4 class="custom-card-title mt-4 mb-4">Photo Gallery</h4>

              <div class="container">
                <div class="row row-cols-1 row-cols-md-2 g-3">
                  <div class="col" *ngFor="let image of project.images">
                    <div class="ratio ratio-16x9 rounded-2 overflow-hidden">
                      <img (click)="openModal(image)" [src]="image" class="img-fluid object-fit-cover"
                           alt="Project Image">
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal" tabindex="-1" aria-hidden="true" id="imageModal">
                <div class="modal-dialog modal-fullscreen d-flex justify-content-center align-items-center">
                  <img [src]="selectedImage" class="rounded shadow-lg img-fluid"
                       style="max-width: 95vw; max-height: 95vh;">
                </div>
              </div>
            </div>


            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
                <a class="btn btn-primary w-25" href="/find-projects">Return to View List</a>
                <button
                  *ngIf="teacherRole === 'admin' || teacherRole === 'teacher' || teacherRole === 'ghs teacher representative'"
                  class="btn btn-primary w-25"
                  (click)="toggleEditing()">
                  Edit
                </button>
                <button *ngIf="teacherRole === 'admin'" class="btn btn-primary w-25" (click)="duplicateProject()">
                  Duplicate
                </button>
              </div>
            </div>
          </div>
          <ng-template #noProject>
            <h4>Loading Project Details...</h4>
          </ng-template>


        </div>

        <ng-template #projectDoesntExist>
          <h3 class="custom-card-title">Project does not exist.</h3>
        </ng-template>


      </div>
    </div>
  </div>
}

<ng-template #notLoaded>
  <div class="container mt-5 pt-5 col-lg-10 col-me-10 col-12 text-center">
    <div class="custom-card-large">
      <h2>You do not have access to this page.</h2>
    </div>
  </div>
</ng-template>
